exports = module.exports = require("../../../node_modules/@expo/webpack-config/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".test_container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    height: 100vh;\n}\n\n.test_img {\n    width: 20rem;\n    margin: 20px;\n}", ""]);

